import React from 'react';

function API() {
  return (
    <>
      <div className="max-w-7xl mx-auto">
        <div className="mb-8">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4"> API документация
          </h1>
          <p className="text-lg text-gray-600"> Полная документация по API для интеграции с SkillGate
          </p>
      </div>

        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 md:p-8 mb-6">
          <h2 className="text-2xl font-semibold text-gray-900 mb-4">Доступ к API документации</h2>
          <p className="text-gray-700 mb-4"> Полная интерактивная документация API доступна по следующим адресам:
          </p>
          <div className="space-y-4">
            <div className="bg-blue-50 border border-blue-200 p-4 rounded-lg">
              <h3 className="font-semibold text-blue-900 mb-2">Swagger UI</h3>
              <a
                href="https://api1.skillgate.pro/docs"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 hover:text-blue-800 underline break-all"
              >
                https://api1.skillgate.pro/docs
              </a>
              <p className="text-sm text-blue-700 mt-2"> Интерактивная документация с возможностью тестирования API прямо в браузере
              </p>
            </div>
            <div className="bg-green-50 border border-green-200 p-4 rounded-lg">
              <h3 className="font-semibold text-green-900 mb-2">ReDoc</h3>
              <a
                href="https://api1.skillgate.pro/redoc"
                target="_blank"
                rel="noopener noreferrer"
                className="text-green-600 hover:text-green-800 underline break-all"
              >
                https://api1.skillgate.pro/redoc
              </a>
              <p className="text-sm text-green-700 mt-2"> Альтернативная документация в формате ReDoc
              </p>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 md:p-8 mb-6">
          <h2 className="text-2xl font-semibold text-gray-900 mb-4">Авторизация в API</h2>
          <p className="text-gray-700 mb-4"> Для использования API необходимо пройти авторизацию:
          </p>
          <ol className="list-decimal list-inside space-y-3 text-gray-700 ml-4">
            <li>Зарегистрируйтесь в системе через <code className="bg-gray-100 px-1.5 py-0.5 rounded">POST /api/auth/register</code></li>
            <li>Войдите в систему через <code className="bg-gray-100 px-1.5 py-0.5 rounded">POST /api/auth/login</code></li>
            <li>Получите токен доступа из ответа</li>
            <li>Используйте токен в заголовке запросов: <code className="bg-gray-100 px-1.5 py-0.5 rounded">Authorization: Bearer {`{token}`}</code></li>
          </ol>
          <div className="bg-yellow-50 border border-yellow-200 p-4 rounded-lg mt-4">
            <p className="text-yellow-800 text-sm">
              <strong>Важно:</strong> Токен действителен в течение 7 дней (по умолчанию). После истечения срока необходимо войти заново.
            </p>
          </div>
        </div>

        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 md:p-8 mb-6">
          <h2 className="text-2xl font-semibold text-gray-900 mb-4">Основные endpoints</h2>
          
          <div className="space-y-6">
            <div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3"> Авторизация</h3>
              <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
                <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                  <li><code className="bg-gray-100 px-1.5 py-0.5 rounded">POST /api/auth/register</code> - регистрация нового пользователя</li>
                  <li><code className="bg-gray-100 px-1.5 py-0.5 rounded">POST /api/auth/login</code> - вход в систему</li>
                  <li><code className="bg-gray-100 px-1.5 py-0.5 rounded">GET /api/auth/me</code> - информация о текущем пользователе</li>
                  <li><code className="bg-gray-100 px-1.5 py-0.5 rounded">POST /api/auth/send-verification-code</code> - отправка кода подтверждения email</li>
                  <li><code className="bg-gray-100 px-1.5 py-0.5 rounded">POST /api/auth/verify-code</code> - проверка кода подтверждения</li>
                  <li><code className="bg-gray-100 px-1.5 py-0.5 rounded">POST /api/auth/forgot-password</code> - запрос восстановления пароля</li>
                  <li><code className="bg-gray-100 px-1.5 py-0.5 rounded">POST /api/auth/reset-password</code> - установка нового пароля</li>
                </ul>
              </div>
            </div>

            <div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3"> Базы вопросов</h3>
              <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
                <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                  <li><code className="bg-gray-100 px-1.5 py-0.5 rounded">GET /api/question-banks</code> - список всех баз вопросов</li>
                  <li><code className="bg-gray-100 px-1.5 py-0.5 rounded">POST /api/question-banks</code> - создание новой базы (multipart/form-data: name, csv_file, images[])</li>
                  <li><code className="bg-gray-100 px-1.5 py-0.5 rounded">GET /api/question-banks/{`{id}`}</code> - детальная информация о базе с вопросами</li>
                </ul>
              </div>
            </div>

            <div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3"> Тест-схемы</h3>
              <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
                <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                  <li><code className="bg-gray-100 px-1.5 py-0.5 rounded">GET /api/test-schemas</code> - список всех тест-схем</li>
                  <li><code className="bg-gray-100 px-1.5 py-0.5 rounded">POST /api/test-schemas</code> - создание новой тест-схемы</li>
                  <li><code className="bg-gray-100 px-1.5 py-0.5 rounded">GET /api/test-schemas/{`{id}`}</code> - детали тест-схемы</li>
                  <li><code className="bg-gray-100 px-1.5 py-0.5 rounded">DELETE /api/test-schemas/{`{id}`}</code> - удаление тест-схемы</li>
                </ul>
              </div>
            </div>

            <div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3"> Приглашения</h3>
              <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
                <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                  <li><code className="bg-gray-100 px-1.5 py-0.5 rounded">POST /api/test-invitations</code> - создание нового приглашения</li>
                  <li><code className="bg-gray-100 px-1.5 py-0.5 rounded">GET /api/test-schemas/{`{id}`}/invitations</code> - список приглашений для тест-схемы</li>
                  <li><code className="bg-gray-100 px-1.5 py-0.5 rounded">GET /api/invitations</code> - список всех приглашений</li>
                  <li><code className="bg-gray-100 px-1.5 py-0.5 rounded">PUT /api/test-invitations/{`{id}`}/status</code> - обновление статуса приглашения</li>
                  <li><code className="bg-gray-100 px-1.5 py-0.5 rounded">PUT /api/test-invitations/{`{id}`}/archive</code> - архивирование/разархивирование</li>
                </ul>
              </div>
            </div>

            <div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3"> Результаты тестов</h3>
              <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
                <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                  <li><code className="bg-gray-100 px-1.5 py-0.5 rounded">GET /api/test-invitations/{`{id}`}/results</code> - просмотр результатов теста</li>
                  <li><code className="bg-gray-100 px-1.5 py-0.5 rounded">POST /api/test-invitations/{`{id}`}/pay-for-results</code> - оплата просмотра результатов</li>
                </ul>
                <p className="text-sm text-gray-600 mt-3 ml-4">
                  <strong>Примечание:</strong> Просмотр результатов стоит 100 рублей. Результаты доступны только после оплаты.
                </p>
              </div>
            </div>

            <div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3"> Платежи</h3>
              <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
                <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                  <li><code className="bg-gray-100 px-1.5 py-0.5 rounded">GET /api/payments</code> - список всех платежей</li>
                  <li><code className="bg-gray-100 px-1.5 py-0.5 rounded">POST /api/payments</code> - создание платежа (multipart/form-data: amount, receipt_file)</li>
                  <li><code className="bg-gray-100 px-1.5 py-0.5 rounded">GET /api/payments/{`{id}`}</code> - детали платежа</li>
                  <li><code className="bg-gray-100 px-1.5 py-0.5 rounded">GET /api/payments/{`{id}`}/receipt</code> - получение чека</li>
                </ul>
              </div>
            </div>

            <div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3"> Кандидаты (публичные endpoints)</h3>
              <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
                <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                  <li><code className="bg-gray-100 px-1.5 py-0.5 rounded">GET /api/candidate/test/{`{invitation_code}`}</code> - получение теста по коду приглашения</li>
                  <li><code className="bg-gray-100 px-1.5 py-0.5 rounded">POST /api/candidate/test/{`{invitation_code}`}/submit</code> - отправка ответов на тест</li>
                </ul>
                <div className="bg-blue-50 border border-blue-200 p-3 rounded-lg mt-3 ml-4">
                  <p className="text-sm font-semibold text-blue-900 mb-2">Параметры для submit:</p>
                  <ul className="list-disc list-inside space-y-1 text-sm text-blue-800 ml-2">
                    <li><code className="bg-blue-100 px-1 py-0.5 rounded">answers</code> - массив ответов: <code className="bg-blue-100 px-1 py-0.5 rounded">[{`{"question_id": 1, "answer_text": "ответ"}`}]</code></li>
                    <li><code className="bg-blue-100 px-1 py-0.5 rounded">background_switches_count</code> - количество сворачиваний/разворачиваний приложения (по умолчанию 0)</li>
                    <li><code className="bg-blue-100 px-1 py-0.5 rounded">screenshots_count</code> - количество сделанных скриншотов (по умолчанию 0)</li>
                  </ul>
                </div>
                <p className="text-sm text-gray-600 mt-3 ml-4">
                  <strong>Примечание:</strong> Эти endpoints не требуют авторизации. Используются мобильными приложениями кандидатов.
                </p>
              </div>
            </div>

            <div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3"> Обратная связь</h3>
              <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
                <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                  <li><code className="bg-gray-100 px-1.5 py-0.5 rounded">POST /api/feedback</code> - отправка сообщения обратной связи</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-blue-50 border-2 border-blue-500 p-6 rounded-xl">
          <h2 className="text-blue-700 mb-4 font-semibold text-xl"> Примеры использования</h2>
          
          <div className="space-y-4">
            <div className="bg-white p-4 rounded-lg">
              <h3 className="font-semibold text-gray-900 mb-2">Пример: Вход в систему</h3>
              <pre className="bg-gray-900 text-green-400 p-4 rounded overflow-x-auto text-sm">
{`POST /api/auth/login
Content-Type: application/json

{
  "email": "user@example.com",
  "password": "your_password"
}

Response:
{
  "access_token": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9...",
  "token_type": "bearer"
}`}
              </pre>
            </div>

            <div className="bg-white p-4 rounded-lg">
              <h3 className="font-semibold text-gray-900 mb-2">Пример: Создание приглашения</h3>
              <pre className="bg-gray-900 text-green-400 p-4 rounded overflow-x-auto text-sm">
{`POST /api/test-invitations
Authorization: Bearer {token}
Content-Type: application/json

{
  "test_schema_id": 1,
  "candidate_title": "Иван Иванов"
}

Response:
{
  "id": 1,
  "test_schema_id": 1,
  "candidate_title": "Иван Иванов",
  "invitation_code": "abc123xyz...",
  "created_at": "2025-11-19T20:00:00",
  "completed": false
}`}
              </pre>
            </div>

            <div className="bg-white p-4 rounded-lg">
              <h3 className="font-semibold text-gray-900 mb-2">Пример: Получение теста кандидатом</h3>
              <pre className="bg-gray-900 text-green-400 p-4 rounded overflow-x-auto text-sm">
{`GET /api/candidate/test/abc123xyz...

Response:
{
  "candidate_title": "Иван Иванов",
  "num_questions": 10,
  "questions": [
    {
      "id": 1,
      "section": "Программирование",
      "question_text": "Что такое переменная?",
      "question_type": "text",
      "options": null,
      "weight": 1,
      "time_limit": "60",
      "image_name": null
    },
    ...
  ]
}`}
              </pre>
            </div>

            <div className="bg-white p-4 rounded-lg">
              <h3 className="font-semibold text-gray-900 mb-2">Пример: Отправка ответов на тест</h3>
              <pre className="bg-gray-900 text-green-400 p-4 rounded overflow-x-auto text-sm">
{`POST /api/candidate/test/abc123xyz.../submit
Content-Type: application/json

{
  "answers": [
    {
      "question_id": 1,
      "answer_text": "Переменная - это именованная область памяти"
    },
    {
      "question_id": 2,
      "answer_text": "Ответ на второй вопрос"
    }
  ],
  "background_switches_count": 0,
  "screenshots_count": 0
}

Response:
{
  "message": "Test submitted successfully"
}`}
              </pre>
            </div>
          </div>
        </div>

        <div className="bg-yellow-50 border-2 border-yellow-400 p-6 rounded-xl mt-6">
          <h2 className="text-yellow-800 mb-4 font-semibold text-xl"> Важные замечания</h2>
          <ul className="list-disc list-inside space-y-2 text-yellow-800 ml-4">
            <li>Все запросы к защищенным endpoints требуют токен авторизации в заголовке</li>
            <li>Токен действителен 7 дней, после истечения необходимо войти заново</li>
            <li>При создании базы вопросов используйте multipart/form-data</li>
            <li>Коды приглашений генерируются автоматически и уникальны</li>
            <li>Просмотр результатов требует оплаты (100 рублей)</li>
            <li>Все даты и время возвращаются в формате UTC</li>
          </ul>
        </div>
      </div>
    </>
  );
}

export default API;
